import {
  GRID_DETAIL_PANEL_TOGGLE_FIELD,
  GridColDef,
  GridColumnGroupingModel,
  GridLeafColumn,
} from '@mui/x-data-grid-pro';

import { ColumnVisibilitySelectItem } from '~/components/ColumnVisibilitySelect/ColumnVisibilitySelect';

export const alignColumnDefinitions = (columns: GridColDef[], columnGroupingModel?: GridColumnGroupingModel) => {
  const alignedColumns: ColumnVisibilitySelectItem[] = [];

  // Create a mapping of column fields to their properties
  const columnMapping: Record<string, ColumnVisibilitySelectItem> = {};
  columns.forEach((column) => {
    // exclude the column for toggling master detail panel from the visibility selector
    if (GRID_DETAIL_PANEL_TOGGLE_FIELD === column.field) {
      return;
    }
    const item = {
      name: column.field,
      title: column.headerName,
      disableToggle: column.hideable === false,
    };
    columnMapping[column.field] = item;
    alignedColumns.push(item);
  });

  // Align columnGroups and replace field with column properties
  const alignedColumnGroups: ColumnVisibilitySelectItem[] | undefined = columnGroupingModel?.map((group) => {
    const children = group.children.map((child) => ({
      ...columnMapping[(child as GridLeafColumn).field],
    }));
    return { ...group, name: group.headerName ?? group.groupId, children: children };
  });

  return { alignedColumns, alignedColumnGroups };
};
